export default __webpack_public_path__ + "static/media/banner.b54ee59a.jpg";